import { BaseLayout } from "./baseLayout"
import Big from "big.js"

export const BaseIsoSimple = {
    mixins: [BaseLayout],
    watch: {
        measures: {
            deep: true,
            handler() {
                if (!this.preview) {
                    this.calcDiff()
                    this.debouncedSave()
                }
            }
        },
        // 'data.current_tolerance': {
        //     handler() {
        //         if (!this.preview && (this.data.block.name == "doser" || this.data.block.name == "liter_doser")) {
        //             console.log("$$ changed tolerance, updating")
        //             this.updated = false
        //             this.buildTolerances()
        //             this.handleToleranceChange()
        //             this.updated = true
        //         }
        //     }
        // }
    },
    methods: {
        convertPlaceholders(items, family = "", maxRange = null) {
            switch (family) {
                case "dosatore additivi":
                case "dosatore additivi litri":
                case "sonda umidità":
                case "nawi_special":
                    for (let item of items) {
                        item.primaryReading = item.readingCalc ? _.cloneDeep(item.readingCalc) : _.cloneDeep(item.reading)
                    }
                    break;
                default:
                    for (let item of items) {
                        if (item.mass) {
                            item.reading = item.mass
                            let range = maxRange
                            if(range == null){
                                range = this.calcMinRange(item.reading)
                            }
                            if (this.measures.hi_res == "off") {
                                item.addLoad = this.calculateAddLoadPlaceholder(item.mass, range)
                            }
                            this.changeReading(item, range)
                        }
                    }
            }
        },
        calculateResultTolerance(row) {
            if (this.precision_overflow) {
                row.result = 'failed'
            } else {
                if (row.toleranceError && row.tolerance) {
                    row.result = (Big(row.toleranceError).abs().lte(row.tolerance)) ? 'done' : 'failed'
                }
            }
        },
        handleToleranceError(row, type = "additive") {
            
            let perc_precision = 2
            if (this.measures.toleranceData.t_type && this.measures.toleranceData.t_type == "law") {
                return this.round(this.calc_OIML(this.calcMinRange(row.nom), row.nom))
            } else if (this.measures.toleranceData.t_calc) {
                switch (this.measures.toleranceData.t_calc) {
                    case "perc":
                        if (type == "additive") {
                            if (row.reading && Big(row.reading).gt(0)) {
                                return Big(row.difference).div(row.reading).times(100).abs().toFixed(perc_precision)
                            } else {
                                return Big(0).toFixed(0)
                            }
                        } else if (type == "liter") {
                            if (row.readingCalc && Big(row.readingCalc).gt(0)) {
                                return Big(row.difference).div(row.readingCalc).times(100).abs().toFixed(perc_precision)
                            } else {
                                return Big(0).toFixed(0)
                            }
                        } else if(type == "cemento") {
                            if(row.error && row.reading && Big(row.reading).gt(0)){
                                return Big(row.error).div(row.reading).times(100).abs().toFixed(perc_precision)
                            } else {
                                return Big(0).toFixed(0)
                            }
                        } else {
                            return Big(0).toFixed(perc_precision)
                        }
                    case "val":
                        {
                            let range = this.calcMinRange(row.reading)
                            if (range) {
                                let error = row.difference ? row.difference : row.error
                                return Big(error).div(range.d).abs().toFixed(0)
                            } else {
                                return Big(0).toFixed()
                            }
                        }
                    default:
                        break
                }
            } else {
                return "0"
            }
        },
        calculate_MPE(range, value) {
            if (range) {
                if (this.instrument_data.instrument_class) {
                    return this.calc_MPE(range, value)
                } else {
                    return this.calc_OIML(range, value)
                }
            } else {
                return "0"
            }
        },
        calculateAddLoadPlaceholder(mass, range = null) {
            let currRange = range != null ? range : this.calcMinRange(mass)
            if (currRange != null) {
                if (this.instrument_data.instrument_class) {
                    return (Big(currRange.e).times(0.5)).toString()
                } else {
                    return (Big(currRange.d).times(0.5)).toString()
                }
            }
            return Big(0).toString()
        },
        checkLoad(value, mass, range = null) {
            if (value != undefined && value != null && value != "") {
                let temp = this.checkPrecision(value, this.high_precision)
                if (!temp) {
                    return false
                }
                let currRange = null
                if (range) {
                    currRange = range
                } else {
                    currRange = this.calcMinRange(mass)
                }
                if (currRange) {
                    let curr_div = 0
                    if (this.instrument_data.instrument_class) {
                        curr_div = this.has_hi_res ? currRange.d : Big(currRange.e).div(10).toString()
                    } else {
                        curr_div = Big(currRange.d).div(10).toString()
                    }
                    temp = this.checkDivisions(value, curr_div)
                    if (!temp) {
                        return false
                    }
                    if (this.instrument_data.instrument_class) {
                        if(this.instrument_data.uom == "mg" && Big(currRange.e).lte(1)){
                            return Big(value).lte(Big(currRange.e))
                        }
                        return Big(value).lte(Big(currRange.e).times(0.9))
                    } else {
                        if(this.instrument_data.uom == "mg" && Big(currRange.d).lte(1)){
                            return Big(value).lte(Big(currRange.d))
                        }
                        return Big(value).lte(Big(currRange.d).times(0.9))
                    }
                }
            }
            return false
        },
        addLoadWarning(value, mass, range = null) {
            if (!this.checkLoad(value, mass, range)) {
                return 'error_field'
            }
        },
        changeTolerance(row) {
            if (this.measures.tolerance && row.reading) {
                if (this.measures.tolerance.t_calc == "perc") {
                    row.tolerance = Big(this.measures.tolerance.t_val).div(100).times(row.reading).toString()
                } else if (this.measures.tolerance.t_calc == "div") {
                    let range = this.calcMinRange(row.reading)
                    row.tolerance = Big(this.measures.tolerance.t_val).times(range.d).toString()
                }
            }
        }

    },
    computed: {
        addLoad_overflow() {
            if (this.measures.hi_res == 'off') {
                for (let elm of this.measures.items) {
                    if (!this.checkLoad(elm.addLoad, elm.reading)) {
                        return true
                    }
                }
            } else {
                return false
            }
        },
        comparison_precision(){
            console.log("$$ primaries changed", this.data.primaries)
            return this.findComparisonPrecision()
        },
        // reading_overflow() {
        //     for (let elm of this.measures.items) {
        //         let res = this.checkReading(elm.primaryReading)
        //         switch (res) {
        //             case 'uncomplete':
        //             case 'done':
        //                 break
        //             case 'failed':
        //                 return true
        //         }
        //     }
        //     return false
        // },
    }

}